import React, { useEffect, useState } from 'react';
import { GetAll_ForCurrentUser_Paging_Api, GetAll_ForUser_Paging_Api } from '../../API/ReserveApi';
import { Button, Col, Pagination, Row } from 'antd';
import { DoubleRightOutlined } from '@ant-design/icons';
import { ReservesGrid } from '../Reserve/ReservesGrid';
import { ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';

// ======================================================================
export const AllReservesComponent = ({
    setLoading,
    showMessage,
    forCurrentUser,
    userId,
    userFullName,
    onlyByFoodOrParking = false,
    version,
    currentPage,
    setCurrentPage, // این پراپ را دیگر از بیرون نمی گیریم، چون خودمان مدیریت می کنیم
    onItemClick,
    isShowBack = false,
    onBackClick,
}) => {
    // ======================================================================
    const [reserves, setReserves] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    // وضعیت های جدید برای مرتب سازی
    const [sortColumn, setSortColumn] = useState(undefined);
    const [sortOrder, setSortOrder] = useState(undefined);

    // وضعیت های جدید برای صفحه بندی
    const [currentPageState, setCurrentPageState] = useState(1); // مدیریت currentPage در این کامپوننت
    const [pageSize, setPageSize] = useState(10); // اندازه پیش فرض هر صفحه

    // ======================================================================
    // useEffect حالا به تغییرات currentPageState و pageSize هم واکنش نشان می‌دهد
    useEffect(() => {
        loadData();
    }, [currentPageState, pageSize, version, sortColumn, sortOrder]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            let data;
            const params = {
                isPrimaryOnly: false,
                pageNumber: currentPageState, // ارسال currentPageState
                pageSize: pageSize,         // ارسال pageSize
                sortColumn: sortColumn,
                sortOrder: sortOrder === 'ascend' ? 'asc' : (sortOrder === 'descend' ? 'desc' : undefined),
            };

            if (forCurrentUser)
                data = await GetAll_ForCurrentUser_Paging_Api(params);
            else
                data = await GetAll_ForUser_Paging_Api(params);

            setLoading(false);
            if (data.messageStatus === "Successful") {
                setPageCount(data.messageData.pageCount);
                setTotalItems(data.messageData.totalCount);
                setReserves(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================

    const handleTableChange = (pagination, filters, sorter) => {
        // اگر تغییر در مرتب سازی (sorter) وجود دارد
        if (sorter.columnKey !== sortColumn || sorter.order !== sortOrder) {
            setSortColumn(sorter.columnKey);
            setSortOrder(sorter.order);
            setCurrentPageState(1); // با هر مرتب سازی جدید، به صفحه اول برگردیم
        }
        // در این سناریو، pagination از خود Table Ant Design مدیریت نمی‌شود،
        // بلکه به صورت جداگانه با Pagination کامپوننت مدیریت می‌شود.
        // بنابراین، نیازی به پردازش pagination در اینجا نیست.
    };

    // تابع برای هندل کردن تغییر صفحه
    const onPageChange = (page, currentSize) => {
        setCurrentPageState(page);
        if (currentSize && currentSize !== pageSize) {
            setPageSize(currentSize); // در صورت تغییر pageSize از Pagination کامپوننت
        }
    };

    return (
        <>
            <Row className='sectionTitle'>
                <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                    {isShowBack ?
                        <Button onClick={() => onBackClick()}>
                            <DoubleRightOutlined />
                            بازگشت
                        </Button>
                        : <></>
                    }

                </Col>
                <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                    <h2 >
                        {forCurrentUser ? "رزروهای شما " : "رزروهای " + userFullName}
                    </h2>
                </Col>
                <Col xs={2} sm={2} md={2} lg={4} xl={4} style={{ textAlign: "left" }}>
                </Col>
            </Row>

            <ReservesGrid
                reserves={reserves}
                mode={onlyByFoodOrParking ? "foods" : "reserves"}
                onlyByFoodOrParking={onlyByFoodOrParking}
                onItemClick={onItemClick}
                currentSortColumn={sortColumn}
                currentSortOrder={sortOrder}
                onTableChange={handleTableChange}
                  currentPage={currentPageState} // <--- اضافه کنید
    pageSize={pageSize}
            />

            {totalItems > 0 ? // Pagination فقط زمانی نمایش داده شود که آیتمی وجود داشته باشد
                <ConfigProvider direction="rtl" locale={faIR}>
                    <Pagination
                        current={currentPageState} // استفاده از currentPageState
                        pageSize={pageSize}       // استفاده از pageSize
                        showSizeChanger={true}    // نمایش قابلیت تغییر pageSize
                        pageSizeOptions={['5', '10', '20', '50']} // گزینه های قابل انتخاب برای pageSize
                        showQuickJumper={false}
                        align="center"
                        onChange={onPageChange} // هندل کننده جدید برای تغییر صفحه و pageSize
                        onShowSizeChange={onPageChange} // این هم برای تغییر سایز صفحه است
                        total={totalItems}
                    />
                </ConfigProvider>
                : <></>}
        </>
    )
}







// import React, { useEffect, useState } from 'react';
// import { GetAll_ForCurrentUser_Paging_Api, GetAll_ForUser_Paging_Api } from '../../API/ReserveApi';
// import { Button, Col, Pagination, Row } from 'antd';
// import { DoubleRightOutlined } from '@ant-design/icons';
// import { ReservesGrid } from '../Reserve/ReservesGrid';
// import { ConfigProvider } from 'antd';
// import faIR from 'antd/locale/fa_IR';

// // ======================================================================
// export const AllReservesComponent = ({
//     setLoading,
//     showMessage,
//     forCurrentUser,
//     userId,
//     userFullName,
//     onlyByFoodOrParking = false,
//     version,
//     currentPage,
//     setCurrentPage,
//     onItemClick,
//     isShowBack = false,
//     onBackClick,
//     // isShowFoodReserve = false,
//     // onFoodClick,

// }) => {
//     // ======================================================================
//     const [reserves, setReserves] = useState([]);
//     const [pageCount, setPageCount] = useState(4);
//     // ======================================================================
//     useEffect(() => {
//         loadData();
//     }, [currentPage, version]);
//     // ======================================================================
//     const loadData = async () => {
//         setLoading(true);
//         try {
//             let data;
//             if (forCurrentUser)
//                 data = await GetAll_ForCurrentUser_Paging_Api({ isPrimaryOnly: false, pageNumber: currentPage, });
//             else
//                 data = await GetAll_ForUser_Paging_Api({ userId: userId, isPrimaryOnly: false, pageNumber: currentPage, });

//             setLoading(false);
//             if (data.messageStatus == "Successful") {
//                 setPageCount(data.messageData.pageCount * 10)
//                 setReserves(data.messageData.data);
//             }
//             else
//                 showMessage(data.message, "error")
//         }
//         catch (error) {
//             setLoading(false);
//             showMessage("خطا در ارتباط با سرور.", "error")
//         }
//     }
//     // ======================================================================

//     return (
//         <>
//             <Row className='sectionTitle'>
//                 <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
//                     {isShowBack ?
//                         <Button onClick={() => onBackClick()}>
//                             <DoubleRightOutlined />
//                             بازگشت
//                         </Button>
//                         : <></>
//                     }

//                 </Col>
//                 <Col xs={16} sm={16} md={16} lg={16} xl={16}>
//                     <h2 >
//                         {forCurrentUser ? "رزروهای شما " : "رزروهای " + userFullName}

//                     </h2>
//                 </Col>
//                 <Col xs={2} sm={2} md={2} lg={4} xl={4} style={{ textAlign: "left" }}>
//                 </Col>
//             </Row>

//             <ReservesGrid
//                 reserves={reserves}
//                 rowNumber={1}
//                 mode={onlyByFoodOrParking ? "foods" : "reserves"}
//                 onlyByFoodOrParking={onlyByFoodOrParking}
//                 onItemClick={onItemClick}
//                 // isShowFoodReserve={isShowFoodReserve}
//                 // onFoodClick={onFoodClick}
//             />

//             {reserves.length > 0 ?
//                 <ConfigProvider direction="rtl" locale={faIR}>
//                     <Pagination current={currentPage}
//                         showSizeChanger={false}
//                         showQuickJumper={false}
//                         align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
//                 </ConfigProvider>
//                 : <></>}
//         </>
//     )
// }
